import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';

class NewButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.clearPartReturnOrder();
    this.props.navigateTo(paths.PartsReturnsDetail);
  }

  render() {
    return (
      <Button primary content='NUEVO' onClick={this.handleClick} />
    );
  }
}

const {
  navigateTo,
  clearPartReturnOrder,
} = Actions;

export default connect(null, {
  navigateTo,
  clearPartReturnOrder,
})(NewButton);
